import { Component, Input } from '@angular/core';
import { ButtonConfig } from 'src/app/models/button.component.model';
@Component({
  selector: 'control-list',
  templateUrl: './control-list.component.html'
})
export class ControlListComponent {
  @Input() public config: ButtonConfig[];

  constructor() {}
}
